var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":"Create Awesome 🙌"}},[_c('b-card-text',[_vm._v("This is your second page.")]),_c('b-card-text',[_vm._v("Chocolate sesame snaps pie carrot cake pastry pie lollipop muffin. Carrot cake dragée chupa chups jujubes. Macaroon liquorice cookie wafer tart marzipan bonbon. Gingerbread jelly-o dragée chocolate.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }